var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    clipPath: "url(#clip0_4103_26237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 3.81391 13.1861 0 8.5 0C3.81391 0 0 3.81391 0 8.5C0 13.1861 3.81391 17 8.5 17H16.9261L15.2557 13.6443C16.3828 12.1661 17 10.3626 17 8.5ZM11.098 12.9865H5.9463L3.37043 8.52587L5.9463 4.06522H11.098L13.6739 8.52587L11.098 12.9865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93264 11.0566C10.3308 10.8297 11.2803 9.51224 11.0533 8.11406C10.8264 6.71587 9.50894 5.76639 8.11075 5.99335C6.71256 6.22031 5.76309 7.53775 5.99005 8.93594C6.217 10.3341 7.53445 11.2836 8.93264 11.0566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4103_26237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHexagon);
export default __webpack_public_path__ + "static/media/chat-hexagon.6a019a236cc63f30a861e216b2270a23.svg";
export { ForwardRef as ReactComponent };